// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cpHok","rootMobile":"styles_rootMobile__lXN3a"};